export { default } from './MultiBirthdayForm';



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/MultiBirthday/MultiBirthdayForm/index.js